import { useMemo } from 'react';
import Form from 'src/lib/forms/Form';

type UseFormErrorsParams = {
	formState: Form,
	editedFields: Record<string, boolean>
};

const useFormErrors = ( { formState, editedFields }: UseFormErrorsParams ) => useMemo<Record<string, string>>(
	() => Object.keys( formState.errors )
		.filter( field => editedFields[ field ] )
		.map( field => [ field, formState.errors[ field ][ 0 ] ] )
		.reduce( ( acc, [ field, error ] ) => ( {
			...acc,
			[ field ]: error
		} ), {} ),
	[ formState.errors, editedFields ]
);

export default useFormErrors;
